/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 11:48:36
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-24 12:22:07
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/hooks.ts
 */
import _ from 'lodash';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { Image } from 'src/types/common/common';
const useSingleImageEffect = (
  image: Image | null,
  fileList: Image[],
  setFileList,
) => {
  useAfterDidMountEffect(() => {
    if (!image) {
      setFileList([]);
    } else {
      const _current = _.last(fileList);
      const _imageUuid = image.uuid;
      const _currentUuid = (_current || { uuid: null }).uuid;
      const nImageSetting = _.get(image, 'imageSetting');
      const fImageSetting = _.get(_current, 'imageSetting');

      if (
        _imageUuid !== _currentUuid ||
        !_.isEqual(nImageSetting, fImageSetting) ||
        !_.isEqual(image, _current)
      ) {
        setFileList([image]);
      }
    }
  }, [image]);
};

const useMultiImagesEffect = (
  images: Image[] | null,
  fileList: Image[],
  setFileList,
) => {
  useAfterDidMountEffect(() => {
    if (!images) {
      setFileList([]);
    } else {
      const _current = fileList.map((i) => i.uuid).sort();
      const _imageUuid = images.map((i) => i.uuid).sort();
      const isEqual = _.isEqual(_current, _imageUuid);
      if (!isEqual) {
        setFileList(images);
      }
    }
  }, [images]);
};
export { useSingleImageEffect, useMultiImagesEffect };
